import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['button', 'form']

  toggle() {
    this.formTarget.classList.toggle('hidden')

    // Update button text
    const button = this.buttonTarget.querySelector('button')
    if (this.formTarget.classList.contains('hidden')) {
      button.textContent = '+ Adicionar Domínio'
    } else {
      button.textContent = '✕ Cancelar'
    }
  }
}
